import React, { useEffect, useRef, useState, } from 'react'
import { Link, } from 'react-router-dom';
import HtmlParser from 'react-html-parser';
import $ from 'jquery';

import ReCAPTCHA from 'react-google-recaptcha';

import {
    responseGet, globalSettings, globalSettingsPassword, styles, validateEmail, dateTimeFormatGlobalSet, awaitDelay, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp,
} from '../../helpers/settings';
import Menu from '../main/Menu';
import axios from 'axios';
import useAuth from '../../controllers/users/useAuth';
import CssfxLoading from '../main/CssfxLoading';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'RegistrationStatus';

export default function RegistrationStatus({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region  Variables
    let result = {};
    let dataObj = {};
    const auth = useAuth();

    const defaultValueFormDataSet = () => {
        return {
            email: '',
            //firstName: '',
            //lastName: '',
            fullName: '',
            password: '',
        };
    }

    const [errorEmail, setErrorEmail] = useState('');
    const [errorPassword, setErrorPassword] = useState('');
    const [formData, setFormData] = useState(defaultValueFormDataSet());
    const [showDetails, setShowDetails] = useState(false);
    const [userLocal, setUserLocal] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const recaptchaRef = useRef(ReCAPTCHA);
    //const [showLoading, setShowLoading] = useState(true);
    const [showLoading, setShowLoading] = useState(false);
    const [showData, setShowData] = useState(false);
    const urlStop = '#nothing';
    const controls = {
        buttons: {
            back: {
                id: 'btnBack',
                className: 'btn btn-outline-primary mx-1',
            },
            home: {
                className: 'btn btn-outline-success',
                id: 'btnHome',
            },
            login: {
                className: 'btn btn-outline-primary mx-1',
                id: 'btnLogin',
            },
            send: {
                className: 'btn btn-outline-primary mx-1',
                id: 'btnSend',
            },
        },
        icons: {
            back: {
                id: 'iconBack',
                className: globalSettings?.icons?.arrowAltCircleLeft,
            },
            home: {
                id: 'iconHome',
                className: globalSettings?.icons?.home,
            },
            login: {
                id: 'iconLogin',
                className: globalSettings?.icons?.powerOff,
            },
            send: {
                id: 'iconSend',
                className: globalSettings?.icons?.checkCircle,
            },
        },
        inputs: {
            email: {
                id: 'inputEmail',
            },
            password: {
                id: 'inputPassword',
            },
        },
        spinners: {
            back: {
                id: 'spBack',
                className: '',
            },
            home: {
                id: 'spHome',
                className: '',
            },
            login: {
                id: 'spLogin',
                className: '',
            },
            send: {
                id: 'spSend',
                className: '',
            }
        },
        urls: {
            home: {
                id: 'urlhome',
                className: '',
            },
            forgotYourPassword: {
                id: 'urlForgotYourPassword',
                className: 'btn-link',
            },
            reCaptchaPrivaciConditions: {
                id: 'urlReCaptchaPrivaciConditions',
                className: '',
            },
            userRegister: {
                id: 'urlRequestAccount',
                className: '',
            },
            registerStatus: {
                id: 'urlStatusRegister',
                className: '',
            },
        },
    };
    //#endregion  Variables

    //#region  Methods
    const checkFormDataAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'checkFormDataAsync';
        let response = responseGet();
        try {
            setErrorEmail('');
            setErrorPassword('');

            if (isUndNullEmp({ data: formData?.email, subMethod: currentMethod, })?.result) {
                setErrorEmail(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (!validateEmail({ email: formData?.email })) {
                setErrorEmail(globalSettings?.messages?.youMustEnterValidEmail?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formData?.password, subMethod: currentMethod, })?.result) {
                setErrorPassword(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (formData?.password?.length < globalSettingsPassword?.maxLength) {
                setErrorPassword(globalSettings?.messages?.youMustEnterValidPassword?.[languageObj?.id]);
                response.isWarning = true;
            }
            return response;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                response.msgText += `Sub method: ${subMethod}</br>`
            }
            response.msgText += `Error: ${ex?.message}`
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const checkRegisterStatusAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'checkRegisterStatusAsync';
        let response = responseGet();
        try {
            //#region variables
            let userVzLa = {};
            //#endregion variables

            //#region initialize
            e?.preventDefault();
            setShowPassword(false);
            //#endregion initialize

            //#region check form data
            response = await checkFormDataAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion check form data

            await controlsStatusSetAsync({ processType: 1, subMethod: currentMethod, });
            //setShowLoading(true);
            setShowData(false);

            //#region get recaptcha token
            const recaptchaToken = await recaptchaRef.current.executeAsync();
            recaptchaRef?.current?.reset();
            //#endregion get recaptcha token

            //#region check register status

            dataObj = {
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlAccounts}${globalSettings?.app?.backend?.urlRegisterStatus}`,
                email: formData?.email,
                password: formData?.password,
                recaptchaToken: recaptchaToken,
                languageId: languageObj?.id,
            }

            result = await axios?.post(
                dataObj?.url,
                dataObj,
            );
            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
                setShowLoading(false);
                setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            userVzLa = response?.result?.userVzLa;
            setUserLocal(userVzLa);

            //#region old code
            //setFormData({ ...formData, 'firstName': userVzLa?.firstName, 'lastName': userVzLa?.lastName, });
            //#endregion old code
            setFormData({ ...formData, fullName: `${userVzLa?.firstName}, ${userVzLa?.lastName}`, });
            setShowDetails(true);
            //#endregion check register status

            await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
            setShowLoading(false);
            setShowData(true);
        } catch (ex) {
            await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
            setShowLoading(false);
            setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                response.msgText += `Sub method: ${subMethod}</br>`
            }
            response.msgText += `Error: ${ex?.message}`
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const goBackAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'goBackAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            await controlsStatusSetAsync({ processType: 4, subMethod: currentMethod, });
            //setShowLoading(true);
            setShowData(false);

            setShowPassword(false);
            setFormData(defaultValueFormDataSet());

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            setShowLoading(false);
            setShowData(false);
            setShowDetails(false);
            await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
            setShowLoading(false);
            setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                response.msgText += `Sub method: ${subMethod}</br>`
            }
            response.msgText += `Error: ${ex?.message}`
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        //setShowLoading(true);
        setShowData(false);
        await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
        setShowLoading(false);
        setShowData(true);
        try {
        } catch (ex) {
            setShowLoading(false);
            setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                response.msgText += `Sub method: ${subMethod}</br>`
            }
            response.msgText += `Error: ${ex?.message}`
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const buttonsProcessAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'buttonsProcessAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e?.preventDefault, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            setShowPassword(false);
            setShowDetails(false);
            setFormData(defaultValueFormDataSet());

            switch (e?.currentTarget?.id) {
                case controls?.buttons?.home?.id:
                    await controlsStatusSetAsync({ processType: 2, subMethod: currentMethod, });
                    //await new Promise((resolve) => setTimeout(resolve, 1000));
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                    window.location.href = globalSettings?.app?.backend?.urlHome;
                    break;
                case controls?.buttons?.login?.id:
                    await controlsStatusSetAsync({ processType: 3, subMethod: currentMethod, });
                    //await new Promise((resolve) => setTimeout(resolve, 1000));
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                    window.location.href = globalSettings?.app?.backend?.urlLogin;
                    break;
                default:
                    await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
                    break;
            }
        } catch (ex) {
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const controlsStatusSetAsync = async ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.send?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.send?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.send?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.icons?.home?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.home?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.home?.id}`)?.removeClass();

                    $(`#${controls?.icons?.login?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.login?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.login?.id}`)?.removeClass();

                    $(`#${controls?.icons?.send?.id}`)?.addClass(controls?.icons?.send?.className);
                    $(`#${controls?.buttons?.send?.id}`)?.addClass(controls?.buttons?.send?.className);
                    $(`#${controls?.spinners?.send?.id}`)?.addClass(controls?.spinners?.send?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.icons?.home?.id}`)?.addClass(controls?.icons?.home?.className);
                    $(`#${controls?.buttons?.home?.id}`)?.addClass(controls?.buttons?.home?.className);
                    $(`#${controls?.spinners?.home?.id}`)?.addClass(controls?.spinners?.home?.className);

                    $(`#${controls?.icons?.login?.id}`)?.addClass(controls?.icons?.login?.className);
                    $(`#${controls?.buttons?.login?.id}`)?.addClass(controls?.buttons?.login?.className);
                    $(`#${controls?.spinners?.login?.id}`)?.addClass(controls?.spinners?.login?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.send?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.send.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.home?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.home.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.login?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));

            $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
                'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
                'target': (processType !== 0 ? '' : '_blank'),
            });

            if (processType !== 0) {
                $(`#${controls?.buttons?.send?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.home?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            console.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - form' });
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion  Variables

    return (
        <div>
            <Menu viewName='home' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.checkRegistrationStatus?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    {/*<li className='breadcrumb-item'><a href='#'>Home</a></li>*/}
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.checkRegistrationStatus?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='login-box' style={styles?.loginBox}>

                            <div className='card card-primary card-outline shadow-lg'>

                                {/*Header*/}
                                <div className='card-header'>
                                    <h6><img src={globalSettings?.images?.userLogin} alt='registerStatus' style={styles?.cardHeaderLogo} /> - {globalSettings?.labels?.checkRegistrationStatus?.[languageObj?.id]}</h6>
                                </div>

                                <form onSubmit={!showDetails ? (e) => checkRegisterStatusAsync({ e: e, subMethod: 'formId' }) : (e) => goBackAsync({ e: e, subMethod: 'formId' })} method='post'>

                                    {/*Body*/}
                                    <div className='card-body'>
                                        <p className='login-box-msg'>{!showDetails ? globalSettings?.labels?.enterYourEmailCheckStatus?.[languageObj?.id] : globalSettings?.labels?.user?.[languageObj?.id]}</p>

                                        {showDetails ?
                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    {/* <input value={(isUndNullEmp({ data: formData?.firstName, subMethod: currentMethod, })?.result && isUndNullEmp({ data: formData?.lastName, subMethod: currentMethod, })?.result ? `` : `${formData?.firstName} ${formData?.lastName}`)} */}
                                                    <input value={(isUndNullEmp({ data: formData?.fullName, subMethod: currentMethod, })?.result ? `` : `${formData?.fullName}`)}
                                                        className='form-control'
                                                        placeholder={globalSettings?.labels?.firstName?.[languageObj?.id]}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.firstName?.[languageObj?.id]}
                                                        readOnly={showDetails} />
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text'>
                                                            <span className='fas fa-user prefix grey-text' />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            : <></>}
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.email?.id}
                                                    onChange={(e) => setFormData({ ...formData, 'email': e.target?.value })}
                                                    onFocus={() => setErrorEmail('')}
                                                    value={formData?.email}
                                                    className='form-control'
                                                    placeholder={globalSettings?.labels?.email?.[languageObj?.id]}
                                                    readOnly={showDetails}
                                                    tooltip='tooltip'
                                                    //autoFocus 
                                                    title={globalSettings?.labels?.email?.[languageObj?.id]}/>
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={globalSettings?.icons?.envelope} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorEmail)}</div>
                                        </div>

                                        {!showDetails ?
                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <input id={controls?.inputs?.password?.id}
                                                        onChange={(e) => setFormData({ ...formData, 'password': e.target?.value })}
                                                        onFocus={() => setErrorPassword('')}
                                                        value={formData?.password}
                                                        className='form-control'
                                                        placeholder={globalSettings?.labels?.password?.[languageObj?.id]}
                                                        readOnly={showDetails}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.password?.[languageObj?.id]}
                                                        type={showPassword ? 'text' : 'password'}
                                                    />
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text' type='button'>
                                                            <span className={showPassword ? globalSettings?.icons?.eyeIpasswordIpassword : globalSettings?.icons?.eyeSlashIpasswordIpassword}
                                                                onClick={(e) => setShowPassword(!showPassword)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorPassword)}</div>
                                            </div>

                                            : <></>}

                                        <div>
                                            <i className={globalSettings?.icons?.lock} />
                                            {/* {' '}<Link to={globalSettings?.app?.backend?.urlForgotPassword} className='btn-link'>{globalSettings?.labels?.forgotYourPassword?.[languageObj?.id]}</Link> */}
                                            {' '}<a id={controls?.urls?.forgotYourPassword?.id} href={globalSettings?.app?.backend?.urlForgotPassword} className='btn-link'>{globalSettings?.labels?.forgotYourPassword?.[languageObj?.id]}</a>
                                        </div>
                                        <div>
                                            <i className={globalSettings?.icons?.userCheck} />
                                            {/* {' '}<Link to={globalSettings?.app?.backend?.urlUserRegister} className='btn-link'>{globalSettings?.labels?.registerNewMembership}</Link> */}
                                            {' '}<a id={controls?.urls?.userRegister?.id} href={globalSettings?.app?.backend?.urlUserRegister} className='btn-link'>{globalSettings?.labels?.registerNewMembership?.[languageObj?.id]}</a>
                                        </div>
                                    </div>

                                    {/*Footer*/}
                                    <div className='card-footer'>
                                        <div className='form-group text-right'>
                                            <button id={controls?.buttons?.send?.id}
                                                className={controls?.buttons?.send?.className}
                                                hidden={showDetails}
                                                title={globalSettings?.labels?.send?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                type='submit'>
                                                <i id={controls?.icons?.send?.id} className={controls?.icons?.send?.className} /> <span id={controls?.spinners?.send?.id} className='' aria-hidden='true'></span>
                                            </button>
                                            <button id={controls?.buttons?.back?.id}
                                                className={controls?.buttons?.back?.className}
                                                hidden={!showDetails}
                                                title={globalSettings?.labels?.back?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                type='submit'>
                                                <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                            </button>
                                            <button id={controls?.buttons?.home?.id}
                                                className={controls?.buttons?.home?.className}
                                                title={globalSettings?.labels?.home?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                type='button'
                                                onClick={(e) => buttonsProcessAsync({ e: e, subMethod: e?.currentTarget?.id, })}>
                                                <i id={controls?.icons?.home?.id} className={controls?.icons?.home?.className} /> <span id={controls?.spinners?.home?.id} className='' aria-hidden='true'></span>
                                            </button>
                                            <button id={controls?.buttons?.login?.id}
                                                className={controls?.buttons?.login?.className}
                                                title={globalSettings?.labels?.login?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                type='button'
                                                onClick={(e) => buttonsProcessAsync({ e: e, subMethod: e?.currentTarget?.id, })}>
                                                <i id={controls?.icons?.login?.id} className={controls?.icons?.login?.className} /> <span id={controls?.spinners?.login?.id} className='' aria-hidden='true'></span>
                                            </button>
                                            {/* <Link to={globalSettings?.app?.backend?.urlHome}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.home?.[languageObj?.id]}
                                                className='btn btn-outline-success'>
                                                <i className={globalSettings?.icons?.home} />
                                            </Link>
                                            <a href={globalSettings?.app?.backend?.urlLogin}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.login?.[languageObj?.id]}
                                                className='btn btn-outline-primary mx-1'>
                                                <i className={globalSettings?.icons?.powerOff} />
                                            </a> */}
                                        </div>
                                    </div>

                                </form>

                                <div hidden>
                                    <ReCAPTCHA className='g-recaptcha'
                                        ref={recaptchaRef}
                                        sitekey={globalSettings?.app?.reCAPTCHA?.reCAPTCHASiteKey}
                                        size='invisible' />
                                </div>

                            </div>
                            <div className='text-muted text-center text-small'>
                                <p>
                                    <small>{globalSettings?.labels?.protectedByReCAPTCHA?.[languageObj?.id]} -
                                        <a id={controls?.urls?.reCaptchaPrivaciConditions?.id}
                                            target='_blank'
                                            href={globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions}
                                            rel='noreferrer'>{globalSettings?.labels?.privacyAndConditions?.[languageObj?.id]}
                                        </a>
                                    </small>
                                </p>
                            </div>

                        </div>
                        <br />

                        <div>
                            {!showLoading ?
                                <div>
                                    {showData ?
                                        <div>
                                            {showDetails ?
                                                <section className='content'>
                                                    <div className='container-fluid'>
                                                        <div className='row'>
                                                            <div className='col-md-12'>

                                                                <div className='timeline'>

                                                                    <div className='time-label'>
                                                                        {/* <span className='bg-green'>{dateTimeFormatSetTwo(new Date(userLocal?.created).toLocaleString(), 'm/d/y', 0)}</span> */}
                                                                        <span className='bg-green'>{dateTimeFormatGlobalSet({ date: userLocal?.created, type: globalSettings?.react?.tempusDominus?.format?.date?.dmy, format: 0, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result}</span>
                                                                    </div>
                                                                    <div>
                                                                        <i className={`${globalSettings?.icons?.userCheck} bg-green`} />
                                                                        <div className='timeline-item'>
                                                                            {/* <span className='time'><i className={globalSettings?.icons?.clock} /> {dateTimeFormatSetTwo(new Date(userLocal?.created).toLocaleString(), '', 24)}</span> */}
                                                                            <span className='time'><i className={globalSettings?.icons?.clock} /> {dateTimeFormatGlobalSet({ date: userLocal?.created, type: '', format: languageObj?.format?.time?.type, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result}</span>
                                                                            <h4 className='timeline-header'><label className='text-primary'>{globalSettings?.labels?.registrationDone}.</label> {globalSettings?.messages?.theUserHasAlreadyMadeRegistration?.[languageObj?.id]}.</h4>
                                                                        </div>
                                                                    </div>

                                                                    <div className='time-label'>
                                                                        {/* <span className={userLocal?.emailVerified ? 'bg-green' : 'bg-yellow'}>{userLocal?.emailVerified ? dateTimeFormatSetTwo(new Date(userLocal?.emailVerifiedDate).toLocaleString(), 'm/d/y', 0) : `${globalSettings?.labels?.pending?.[languageObj?.id]}...`}</span> */}
                                                                        <span className={userLocal?.emailVerified ? 'bg-green' : 'bg-yellow'}>{userLocal?.emailVerified ? dateTimeFormatGlobalSet({ date: userLocal?.emailVerifiedDate, type: globalSettings?.react?.tempusDominus?.format?.date?.dmy, format: 0, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result : `${globalSettings?.labels?.pending?.[languageObj?.id]}...`}</span>
                                                                    </div>
                                                                    <div>
                                                                        <i className={userLocal?.emailVerified ? 'fas fa-envelope bg-green' : 'fas fa-envelope bg-yellow'} />
                                                                        <div className='timeline-item'>
                                                                            {/* <span className='time'><i className={globalSettings?.icons?.clock} /> {userLocal?.emailVerified ? dateTimeFormatSetTwo(new Date(userLocal?.emailVerifiedDate).toLocaleString(), '', 24) : '00:00'}</span> */}
                                                                            <span className='time'><i className={globalSettings?.icons?.clock} /> {userLocal?.emailVerified ? dateTimeFormatGlobalSet({ date: userLocal?.emailVerifiedDate, type: '', format: languageObj?.format?.time?.type, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result : '00:00'}</span>
                                                                            <h4 className='timeline-header no-border'><label className='text-primary'> {userLocal?.emailVerified ? globalSettings?.labels?.confirmationDone?.[languageObj?.id] : globalSettings?.labels?.waitingConfirmation?.[languageObj?.id]}.</label> {userLocal?.emailVerified ? `${globalSettings?.messages?.theUserHasConfirmedTheAccount?.[languageObj?.id]}.` : `${globalSettings?.messages?.youMustConfirmYourEmailAccountCompleteRegistration?.[languageObj?.id]}`}</h4>
                                                                        </div>
                                                                    </div>

                                                                    <div className='time-label'>
                                                                        {/* <span className={userLocal?.accountApproved ? 'bg-green' : userLocal?.emailVerified ? 'bg-yellow' : 'bg-gray'}>{userLocal?.accountApproved ? dateTimeFormatSetTwo(new Date(userLocal?.accountApprovedDate).toLocaleString(), 'm/d/y', 0) : `${globalSettings?.labels?.pending?.[languageObj?.id]}...`}</span> */}
                                                                        <span className={userLocal?.accountApproved ? 'bg-green' : userLocal?.emailVerified ? 'bg-yellow' : 'bg-gray'}>{userLocal?.accountApproved ? dateTimeFormatGlobalSet({ date: userLocal?.accountApprovedDate, type: globalSettings?.react?.tempusDominus?.format?.date?.dmy, format: 0, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result : `${globalSettings?.labels?.pending?.[languageObj?.id]}...`}</span>
                                                                    </div>
                                                                    <div>
                                                                        <i className={userLocal?.accountApproved ? 'fas fa-user-shield bg-green' : userLocal?.emailVerified ? 'fas fa-user-shield bg-yellow' : 'fas fa-user-shield bg-gray'} />
                                                                        <div className='timeline-item'>
                                                                            {/* <span className='time'><i className={globalSettings?.icons?.clock} /> {userLocal?.accountApproved ? dateTimeFormatSetTwo(new Date(userLocal?.accountApprovedDate).toLocaleString(), '', 24) : '00:00'}</span> */}
                                                                            <span className='time'><i className={globalSettings?.icons?.clock} /> {userLocal?.accountApproved ? dateTimeFormatGlobalSet({ date: userLocal?.accountApprovedDate, type: '', format: languageObj?.format?.time?.type, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result : '00:00'}</span>
                                                                            <h4 className='timeline-header no-border'><label className='text-primary'> {userLocal?.accountApproved ? globalSettings?.labels?.approvalDone?.[languageObj?.id] : globalSettings?.labels?.waitingApproval?.[languageObj?.id]}.</label> {userLocal?.accountApproved ? `${globalSettings?.labels?.theSystemAdministratorApprovedAccount?.[languageObj?.id]}.` : `${globalSettings?.labels?.systemAdministratorMustApproveAccount?.[languageObj?.id]}.`}</h4>
                                                                        </div>
                                                                    </div>

                                                                    <div className='time-label'>
                                                                        {/* <span className={!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result ? 'bg-green' : userLocal?.accountApproved ? 'bg-yellow' : 'bg-gray'}>{!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result ? dateTimeFormatSetTwo(new Date(userLocal?.roleDate).toLocaleString(), 'm/d/y', 0) : `${globalSettings?.labels?.pending?.[languageObj?.id]}...`}</span> */}
                                                                        <span className={!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result ? 'bg-green' : userLocal?.accountApproved ? 'bg-yellow' : 'bg-gray'}>{!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result ? dateTimeFormatGlobalSet({ date: userLocal?.roleDate, type: globalSettings?.react?.tempusDominus?.format?.date?.dmy, fomar: 0, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result : `${globalSettings?.labels?.pending?.[languageObj?.id]}...`}</span>
                                                                    </div>
                                                                    <div>
                                                                        <i className={!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result ? 'fas fa-user-tag bg-green' : userLocal?.accountApproved ? 'fas fa-user-tag bg-yellow' : 'fas fa-user-tag bg-gray'} />
                                                                        <div className='timeline-item'>
                                                                            {/* <span className='time'><i className={globalSettings?.icons?.clock} /> {!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result ? dateTimeFormatSetTwo(new Date(userLocal?.roleDate).toLocaleString(), '', 24) : '00:00'}</span> */}
                                                                            <span className='time'><i className={globalSettings?.icons?.clock} /> {!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result ? dateTimeFormatGlobalSet({ date: userLocal?.roleDate, type: '', format: languageObj?.format?.time?.type, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result : '00:00'}</span>
                                                                            <h4 className='timeline-header no-border'><label className='text-primary'> {!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result ? globalSettings?.labels?.roleAssignmentDone?.[languageObj?.id] : globalSettings?.labels?.waitingAssignRole?.[languageObj?.id]}.</label> {!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result ? `${globalSettings?.labels?.systemAdministratorAssignedRole?.[languageObj?.id]}.` : `${globalSettings?.labels?.systemAdministratorMustAssignYouRole?.[languageObj?.id]}.`}</h4>
                                                                        </div>
                                                                    </div>

                                                                    <div className='time-label'>
                                                                        {/* <span className={(!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result && userLocal?.emailVerified && userLocal?.accountApproved) ? 'bg-green' : 'bg-gray'}>{(!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result && userLocal?.emailVerified && userLocal?.accountApproved) ? dateTimeFormatSetTwo(new Date(userLocal?.roleDate).toLocaleString(), 'm/d/y', 0) : `${globalSettings?.labels?.pending?.[languageObj?.id]}...`}</span> */}
                                                                        <span className={(!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result && userLocal?.emailVerified && userLocal?.accountApproved) ? 'bg-green' : 'bg-gray'}>{(!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result && userLocal?.emailVerified && userLocal?.accountApproved) ? dateTimeFormatGlobalSet({ date: userLocal?.roleDate, type: globalSettings?.react?.tempusDominus?.format?.date?.dmy, format: 0, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result : `${globalSettings?.labels?.pending?.[languageObj?.id]}...`}</span>
                                                                    </div>
                                                                    <div>
                                                                        <i className={(!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result && userLocal?.emailVerified && userLocal?.accountApproved) ? `${globalSettings?.icons?.checkCircle} bg-green` : `${globalSettings?.icons?.clock} bg-gray`} />
                                                                        <div className='timeline-item'>
                                                                            {/* <span className='time'><i className={globalSettings?.icons?.clock} /> {(!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result && userLocal?.emailVerified && userLocal?.accountApproved) ? dateTimeFormatSetTwo(new Date(userLocal?.roleDate).toLocaleString(), '', 24) : '00:00'}</span> */}
                                                                            <span className='time'><i className={globalSettings?.icons?.clock} /> {(!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result && userLocal?.emailVerified && userLocal?.accountApproved) ? dateTimeFormatGlobalSet({ date: userLocal?.roleDate, type: '', format: languageObj?.format?.time?.type, addTime: false, languageId: languageObj?.id, subMethod: currentMethod, })?.result : '00:00'}</span>
                                                                            <h4 className='timeline-header no-border'><label className='text-primary'> {(!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result && userLocal?.emailVerified && userLocal?.accountApproved) ? globalSettings?.labels?.processesCompletedSuccessfully?.[languageObj?.id] : globalSettings?.labels?.waitingPreviousProcesses?.[languageObj?.id]}.</label> {(!isUndNullEmp({ data: userLocal?.roleId, subMethod: currentMethod, })?.result && userLocal?.emailVerified && userLocal?.accountApproved) ? `${globalSettings?.labels?.youCanNowLogIntoOurSystemWithCredentials?.[languageObj?.id]}.` : `${globalSettings?.labels?.youMustFinishAboveProcessesAccessSystem?.[languageObj?.id]}.`}</h4>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                :
                                                <div></div>
                                            }
                                        </div>
                                        :
                                        <div></div>
                                    }
                                </div>
                                :
                                <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                    width={40}
                                    height={40}
                                    color={globalSettings?.colors?.infoColorExp}
                                    msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                                    msgOrientation='text-center'
                                    msgTextMuted={true} />
                            }
                        </div>

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>

        </div>
    )
}